/**
 * A spreadsheet glyph for the export button.
 *
 * Drawn rather than using Microsoft's Excel product logo: the export is a generic .xlsx
 * file, not an Excel integration, so shipping their product mark would misrepresent the
 * relationship. This uses the familiar green sheet-with-X shape and inherits nothing from
 * the theme, so it reads the same in light and dark.
 */
export function ExcelIcon({ size = 16 }: { size?: number }): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
        fill="#1d6f42"
      />
      <path d="M14 2v6h6z" fill="#ffffff" fillOpacity="0.35" />
      <path
        d="M8.6 11.5h1.7l1.2 2 1.2-2h1.7l-2 3.1 2.1 3.2h-1.7l-1.3-2.1-1.3 2.1H8.5l2.1-3.2z"
        fill="#ffffff"
      />
    </svg>
  );
}
